import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('NoPaddings', null, {
    withChildren: true,
});
